import type { SsoConfig } from "@alascorporation/api-client"

export const ssoConfig: SsoConfig = {
  hubUrl: (import.meta.env.VITE_SSO_HUB_URL as string | undefined) ?? "https://id.satelab.org",
  apiBaseUrl: (import.meta.env.VITE_API_URL as string | undefined) ?? "/api",
  clientId: "gestion",
  redirectUri: `${window.location.origin}/auth/callback`,
  tokenStorageKey: "token",
  userStorageKey: "user",
}
